import React from "react";
import { Routes, Route, Navigate, useParams } from "react-router-dom";

import PartesSeleccionCompania from "../views/PartesSeleccionCompania";
import ParteFormulario from "../views/ParteFormulario";
import PartesLista from "../views/PartesLista";
import PartesEditar from "../views/PartesEditar";
import PartesEliminar from "../views/PartesEliminar";

export default function PartesRouter() {
  const { cuerpoSlug } = useParams();
  return (
    <Routes>
      <Route path="/" element={<PartesSeleccionCompania />} />
      <Route path="/nuevo" element={<ParteFormulario />} />
      <Route path="/lista" element={<PartesLista />} />
      <Route path="/editar" element={<PartesEditar />} />
      <Route path="/eliminar" element={<PartesEliminar />} />

      {/* fallback */}
      <Route path="*" element={<Navigate to={`/${cuerpoSlug}/partes`} replace />} />
    </Routes>
  );
}
